import jwtAxios from "@crema/services/auth/jwt-auth";
import {
  FETCH_START,
  FETCH_ERROR,
  FETCH_SUCCESS,
  GET_KNOWLEDGE_POSTS,
  GET_ACTIVE_USERS,
  GET_POPOLAR_POST,
  UPDATE_KNOWLEDGE_POST,
  GET_DETAIL_POST,
  GET_OTHER_POST,
  GET_PROFILE_ACTIVITY,
  GET_PROFILE_ARTICLE,
  GET_PROFILE_ID,
  GET_LIST_CATEGORY,
  GET_LIST_COMPETENCE,
  ADD_COMMENT_POST,
  RESET_DETAIL_POST,
  SHOW_MESSAGE,
  GET_LIST_VIEWED_POST,
  GET_LIST_LIKED_POST,
  UPDATE_LIKED_POST_IN_DETAIL,
  UPDATE_LIST_POST_BY_ID,
  DELETE_KATEGORI,
  DELETE_KOMPETENSI,
  GET_UNITKERJA,
  GET_SATKERBYUNKER,
  SET_FILTERSEARCH
}
  from "shared/constants/ActionTypes";
import { API } from 'shared/constants/AppEnums';
import { getListCategory, getListCompetence } from "@crema/services/apis/knowledgemanagement";

export const onGetKMList = (page = 1, isReload = false, limit, type = '', search='', unker='', satker='', category='', competence='') => {
  let url;
  if(search || unker || satker || category || competence) url = limit !== undefined ? API.LINIMASA + `?limit=${limit}&page=${page}&type=${type}&search=${search}&unker=${unker}&satker=${satker}&category=${category}&competence=${competence}` : API.LINIMASA + `?page=${page}&type=${type}&search=${search}&unker=${unker}&satker=${satker}&category=${category}&competence=${competence}`  
  else url = limit !== undefined ? API.LINIMASA + `?limit=${limit}&page=${page}&type=${type}` : API.LINIMASA + `?page=${page}&type=${type}`
 
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .get(url, API.requestOptionsGET())
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: GET_KNOWLEDGE_POSTS,
            payload: { data: data.data, isReload: isReload }
          });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: 'Terjadi Kesalahan',
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetKMListPopular = () => {
  return (dispatch) => {
    let url = API.LINIMASAPOP;
    dispatch({ type: FETCH_START });
    jwtAxios
      .get(url, API.requestOptionsGET())
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_POPOLAR_POST, payload: data.data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: 'Terjadi Kesalahan',
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetMostActiveUser = () => {
  return (dispatch) => {
    let url = API.LINIMASAACTIVEUSER;
    dispatch({ type: FETCH_START });
    jwtAxios
      .get(url, API.requestOptionsGET())
      .then((data) => {
        if (data.status === 200) {
          console.log("data most active user", data);
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_ACTIVE_USERS, payload: data.data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: 'Terjadi Kesalahan',
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
}

export const onGetOtherPost = (id) => {
  return (dispatch) => {
    let url = API.LINIMASAOTHERPOST.replace('$id', id);
    dispatch({ type: FETCH_START });
    jwtAxios
      .get(url, API.requestOptionsGET())
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_OTHER_POST, payload: data.data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: 'Terjadi Kesalahan',
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};


export const onGetDetailPost = (id) => {
  return (dispatch) => {
    let url = API.LINIMASADETAIL.replace('$id', id);
    dispatch({ type: FETCH_START });
    jwtAxios
      .get(url, API.requestOptionsGET())
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_DETAIL_POST, payload: data.data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: 'Terjadi Kesalahan',
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onUpdateLikeKnowledge = (post, id, page) => {
  return (dispatch) => {
    let url = API.LIKEARTICLE.replace('$id', id);
    dispatch({ type: FETCH_START });
    jwtAxios
      .patch(url, undefined, API.requestOptionsPATCH())
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          if (page == 'detail') {
            post.likes_count += 1;
            post.liked = true;
            dispatch({
              type: UPDATE_LIKED_POST_IN_DETAIL,
              payload: post,
            });
          } else {
            dispatch({
              type: UPDATE_KNOWLEDGE_POST,
              payload: { id: id, type: 'like' },
            });
          }
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onUpdateDisLikeKnowledge = (post, id, page) => {
  return (dispatch) => {
    let url = API.DISLIKEARTICLE.replace('$id', id);
    dispatch({ type: FETCH_START });
    jwtAxios
      .patch(url, undefined, API.requestOptionsPATCH())
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          if (page == 'detail') {
            post.likes_count -= 1;
            post.liked = false;
            dispatch({
              type: UPDATE_LIKED_POST_IN_DETAIL,
              payload: post,
            });
          } else {
            dispatch({
              type: UPDATE_KNOWLEDGE_POST,
              payload: { id: id, type: 'dislike' },
            });
          }
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetProfileById = (profileId) => {
  return (dispatch) => {
    let url = API.PROFILE_ID.replace('$id', profileId);
    dispatch({ type: FETCH_START });
    jwtAxios
      .get(url, API.requestOptionsGET())
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: GET_PROFILE_ID,
            payload: data.data,
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetProfileArticle = (profileId, page = null, category) => {
  return (dispatch) => {
    let url;
    if (!page) url = API.PROFILE_ID_ARTICLE.replace('$id', profileId);
    else if (category === '') url = API.PROFILE_ID_ARTICLE.replace('$id', profileId) + `?page=${page}&limit=10`;
    else url = API.PROFILE_ID_ARTICLE.replace('$id', profileId) + `?page=${page}&limit=10&category=${category}`;
    dispatch({ type: FETCH_START });
    jwtAxios
      .get(url, API.requestOptionsGET())
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: GET_PROFILE_ARTICLE,
            payload: data.data,
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetProfileActivity = (profileId, page = null) => {
  return (dispatch) => {
    let url
    if (!page) url = API.PROFILE_ID_ACTIVITY.replace('$id', profileId);
    else url = API.PROFILE_ID_ACTIVITY.replace('$id', profileId) + `?page=${page}`;
    dispatch({ type: FETCH_START });
    jwtAxios
      .get(url, API.requestOptionsGET())
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: GET_PROFILE_ACTIVITY,
            payload: data.data,
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetListCategory = () => {
  return (dispatch) => {
    getListCategory()
      .then(res => {
        dispatch({ type: GET_LIST_CATEGORY, payload: res.results })
      })
      .catch(error => {
        dispatch({ type: FETCH_ERROR, payload: error })
      })
  }
}

export const onGetListCompetence = () => {
  return (dispatch) => {
    getListCompetence()
      .then(res => {
        dispatch({ type: GET_LIST_COMPETENCE, payload: res.results })
      })
      .catch(error => {
        dispatch({ type: FETCH_ERROR, payload: error })
      })
  }
}

export const onPostAddComment = (dataPost, detailData) => {
  return (dispatch) => {
    let url = API.LINIMASAADDCOMMENT;
    const datapost = dataPost;
    dispatch({ type: FETCH_START });
    jwtAxios
      .post(url, JSON.stringify(datapost), API.requestOptionsPOST())
      .then((data) => {
        const newComment = {
          id: data.data.result.id,
          message: data.data.result.message,
          creator_avatar: data.data.result.creator_avatar,
          creator: data.data.result.creator,
          created_at: data.data.result.created_at,
          is_creator: data.data.result.is_creator,
          child: data.data.result.children
        };

        const index = detailData.comments.findIndex(item => {
          return item.id === data.data.result.id
        })

        if (dataPost.parent_id === '') {
          detailData.comments.unshift(newComment);
          detailData.comment_count += 1;
        } else {
          detailData.comments.splice(index, 1, newComment)
          detailData.comment_count += 1;
        }

        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: SHOW_MESSAGE, payload: 'Komentar Berhasil Ditambahkan' });
          dispatch({
            type: ADD_COMMENT_POST,
            payload: detailData,
          });
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const updateListPostbyId = (dataUpdate) => {
  return (dispatch) => {
    dispatch({ type: UPDATE_LIST_POST_BY_ID, payload: dataUpdate });
  }
}

export const resetDetailKnowledge = () => {
  return (dispatch) => {
    dispatch({ type: RESET_DETAIL_POST })
  }
}

export const onGetListViewedPost = (id, handleClose) => {
  return (dispatch) => {
    let url = API.LISTVIEWEDPOST.replace('$id', id);
    dispatch({ type: FETCH_START });
    jwtAxios
      .get(url, API.requestOptionsGET())
      .then((data) => {
        if (data.status === 200) {
          // console.log("data list viewed post", data);
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_LIST_VIEWED_POST, payload: data.data.results });
        } else {
          handleClose()
          dispatch({
            type: FETCH_ERROR,
            payload: 'Terjadi Kesalahan',
          });
        }
      })
      .catch((error) => {
        handleClose()
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onGetListLikedPost = (id, handleClose) => {
  return (dispatch) => {
    let url = API.LISTLIKEDPOST.replace('$id', id);
    dispatch({ type: FETCH_START });
    jwtAxios
      .get(url, API.requestOptionsGET())
      .then((data) => {
        if (data.status === 200) {
          // console.log("data list liked post", data);
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_LIST_LIKED_POST, payload: data.data.results });
        } else {
          handleClose()
          dispatch({
            type: FETCH_ERROR,
            payload: 'Terjadi Kesalahan',
          });
        }
      })
      .catch((error) => {
        handleClose()
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const onDeleteKategoriKm = () => {
  return (dispatch) => {
    dispatch({ type: DELETE_KATEGORI });
  };
};

export const onDeleteKompetensiKm = () => {
  return (dispatch) => {
    dispatch({ type: DELETE_KOMPETENSI });
  };
};

export const onSatkerByUnker = (id) => {
  return (dispatch) => {
    let url = API.GETSATKERBYUNKER.replace('$id', id);
    // dispatch({ type: FETCH_START })
    jwtAxios
      .get(url, API.requestOptionsGET())
      .then((data) => {
        if (data.status === 200) {
          // dispatch({ type: FETCH_SUCCESS })
          dispatch({ type: GET_SATKERBYUNKER, payload: data.data.results })
        } else {
          dispatch({ type: FETCH_ERROR, payload: data.data })
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error })
      })
  }
}

export const onGetUnker = () => {
  return (dispatch) => {
    let url = API.GETUNKER
    // dispatch({ type: FETCH_START })
    jwtAxios
      .get(url, API.requestOptionsGET())
      .then((data) => {
        if (data.status === 200) {
          // dispatch({ type: FETCH_SUCCESS })
          dispatch({ type: GET_UNITKERJA, payload: data.data.results })
        } else {
          dispatch({ type: FETCH_ERROR, payload: data.data })
        }
      })
      .catch((error) => {
        dispatch({ type: FETCH_ERROR, payload: error })
      })
  }
}

export const onSetFilterSearch = (search, unker, satker, category, competence, idUnker, dataCategory, dataCompetence) => {
  return (dispatch) => {
    const data = {
      search: search,
      unker: unker,
      satker: satker,
      category: category,
      competence: competence,
      idUnker:idUnker,
      dataCategory:dataCategory,
      dataCompetence:dataCompetence
    }
    dispatch({type: SET_FILTERSEARCH, payload: data})
  }
}